import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findHeadquartersReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`report/findHeadquartersReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findOrgTree({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`org/findOrgTree`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findeadquartersOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`report/findeadquartersOrder`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findEducationReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findQueryProductReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findQueryProductOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findQueryProductOrder`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //明细报表
  findServerReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`customerStatistics/findServerDetail`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //数量报表
  findServerNumberReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`customerStatistics/findServerNumber`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //新增和完成服务报表
  findServerProgress({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`reportServiceProgress/findList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //机构统计
  findIntenReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findIntenReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //省份机构统计
  findProIntenReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findProIntenReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //提交人转案后业绩
  findServerSubmitUserAchievementReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findServerSubmitUserAchievementReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  //讲师转案后业绩
  findServerLecturersAchievementReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findServerLecturersAchievementReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findProductClassList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findProductClassList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findTitleList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/consumeReport/findTitleList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/consumeReport/findReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findTitle({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/consumeReport/findTitleList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findTitle2({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`customerStatistics/findProductList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findTransferStatistics({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`customerStatistics/findTransferStatistics`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findProductList({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`customerStatistics/findProductList`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findCustomerReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`customerStatistics/findHeadquartersReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findNewServerStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/customerStatistics/findServerStep`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findReportForNewReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/consumeReport/findAchievementReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findTitleForNewReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/consumeReport/findAchievementTitleList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findCampusIncomeReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findCampusIncomeReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findOrderList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findFranchiseeReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findFranchiseeReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findFranchiseeReportExport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/selectReport/findFranchiseeReportExport',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  findOrgProductReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findOrgProductReport`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findOrderProductList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`selectReport/findOrderProductList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findOrgProductReportExport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/selectReport/findOrgProductReportExport',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  //B2C报表
  findB2CReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`reportb2c/findList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportThis({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: 'reportb2c/exportList',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  exportServiceProgress({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: 'reportServiceProgress/exportList',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  //产品转案明细报表
  findProductServerReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`sales/report`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/sales/exportReport',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
}